import React from 'react';

import classNames from 'classnames';

import { DragIcon } from '@anyx/shared-icons';


export const DragHandler = React.forwardRef<
  HTMLButtonElement,
  React.HTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  return (
    <button
      type="button"
      ref={ref}
      className={classNames('crm-sortable__drag-handler', className)}
      {...props}
    >
      <DragIcon className="h-full w-full" />
    </button>
  );
});
